import { wordRank } from "@/lib/poetry/dict";

const LETTERS = "abcdefghijklmnopqrstuvwxyz'";
const MY = "lf-mywords";
let mine = null;
const myWords = () => (mine ||= new Set(JSON.parse(localStorage.getItem(MY) || "[]")));
export const addMyWord = (w) => { myWords().add(w.toLowerCase()); localStorage.setItem(MY, JSON.stringify([...myWords()].slice(-3000))); };

const edits1 = (w) => {
  const out = [];
  for (let i = 0; i <= w.length; i += 1) {
    const a = w.slice(0, i), b = w.slice(i);
    if (b) out.push(a + b.slice(1));
    if (b.length > 1) out.push(a + b[1] + b[0] + b.slice(2));
    for (const c of LETTERS) { if (b) out.push(a + c + b.slice(1)); out.push(a + c + b); }
  }
  return out;
};

const best = (cands) => {
  let pick = null, r = Infinity;
  for (const c of cands) { const x = wordRank(c); if (x !== undefined && x < r) { r = x; pick = c; } }
  return pick;
};

const suggest = (w) => {
  const e1 = edits1(w);
  const one = best(e1);
  if (one || w.length > 9) return one;
  return best(e1.filter((x) => x.length > 2).slice(0, 400).flatMap(edits1));
};

const ok = (w, names) => {
  if (wordRank(w) !== undefined || myWords().has(w) || names.has(w)) return true;
  const base = w.replace(/(?:'s|s'|n't|'ll|'re|'ve|'d|'m)$/, "");
  return base !== w && (wordRank(base) !== undefined || names.has(base));
};

const keepCase = (src, fix) => (src[0] === src[0].toUpperCase() ? fix[0].toUpperCase() + fix.slice(1) : fix);
const AN_CONS = /^(uni|use|usu|uti|eu|one|once|ure)/i;
const A_VOWEL = /^(hour|honest|honou?r|heir)/i;

const grammar = (text) => {
  const out = [];
  const add = (original, suggestion, reason) => out.push({ original, suggestion, kind: "grammar", reason });
  for (const m of text.matchAll(/\b(\w+)\s+\1\b/gi)) if (!/^(had|that|very|no|ha|bye|so|now)$/i.test(m[1])) add(m[0], m[1], "Repeated word");
  for (const m of text.matchAll(/\b(a|an)\s+([A-Za-z]+)/gi)) {
    const [art, w] = [m[1], m[2]];
    const vowel = (/^[aeiou]/i.test(w) && !AN_CONS.test(w)) || A_VOWEL.test(w);
    if (art.toLowerCase() === "a" && vowel) add(m[0], `${keepCase(art, "an")} ${w}`, "Use “an” before a vowel sound");
    if (art.toLowerCase() === "an" && !vowel && w.length > 1 && !/^[A-Z]{2,}/.test(w)) add(m[0], `${keepCase(art, "a")} ${w}`, "Use “a” before a consonant sound");
  }
  for (const m of text.matchAll(/(^|\s)i(?=\s|'|’|[,.!?])/g)) add(`${m[0]}`, `${m[1]}I`, "Capital “I”");
  for (const m of text.matchAll(/\S+ {2,}\S+/g)) add(m[0], m[0].replace(/ {2,}/, " "), "Double space");
  for (const m of text.matchAll(/\w+ +([,;:!?])/g)) if (m[1] !== ":" || !/\d/.test(m[0])) add(m[0], m[0].replace(/ +(?=[,;:!?])/, ""), "No space before punctuation");
  for (const m of text.matchAll(/[a-z]{2,}[.!?] +([a-z]+)/g)) if (!/^(e\.g|i\.e|etc|vs|mr|mrs|dr|st)\./i.test(m[0])) add(m[0], m[0].replace(/[a-z]+$/, (x) => x[0].toUpperCase() + x.slice(1)), "Start the sentence with a capital");
  for (const m of text.matchAll(/[a-z]{2,}[,;]([A-Za-z]{2,})/g)) add(m[0], m[0].replace(/([,;])/, "$1 "), "Add a space after the comma");
  return out;
};

// Free, on-device spelling and grammar check for one paragraph.
export const checkParagraph = (text, names) => {
  const out = grammar(text);
  const seen = new Set(out.map((f) => f.original));
  for (const m of text.matchAll(/(?<![\w'’-])[a-z][a-z'’]*(?:-[a-z][a-z'’]*)*(?![\w'’-])/g)) {
    for (const part of m[0].split("-")) {
      const raw = part.replace(/^['’]+|['’]+$/g, ""), w = raw.replace(/’/g, "'");
      if (w.length < 3 || ok(w, names) || seen.has(raw)) continue;
      const s = suggest(w);
      if (s && s !== w) { seen.add(raw); out.push({ original: raw, suggestion: s, kind: "spelling", reason: "Not in the dictionary" }); }
    }
  }
  return out.slice(0, 25).map((f, i) => ({ ...f, id: `${i}-${f.original}` }));
};
